import { notificationsAxiosInstance } from "../utils/axios.instance";

export const getUserNotifications = async (userId: any, skip: number, pageSize: number, type: string) => {
    const response = await notificationsAxiosInstance({
        method: "GET",
        url: `${userId}/${skip}/${pageSize}/${type}`,
    });
    return response.data;
};

export const removeUserNotifications = async (id: string) => {
    const response = await notificationsAxiosInstance({
        method: "DELETE",
        url: id,
    });
    return response.data;
};

export const removeAllUserNotifications = async (userId: any) => {
    const response = await notificationsAxiosInstance({
        method: "DELETE",
        url: `${userId}/all`,
    });
    return response.data;
};
